var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight122X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51531 4.40276C9.14106 4.01223 8.53427 4.01223 8.16002 4.40276C7.78577 4.79328 7.78577 5.42645 8.16002 5.81697L14.6558 12.5951C15.03 12.9857 15.6368 12.9857 16.0111 12.5951C16.3853 12.2046 16.3853 11.5715 16.0111 11.1809L9.51531 4.40276Z",
    fill: "#0177FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0111 12.8169C16.3853 12.4264 16.3853 11.7933 16.0111 11.4027C15.6368 11.0122 15.03 11.0122 14.6558 11.4027L8.16002 18.1809C7.78576 18.5714 7.78576 19.2046 8.16002 19.5951C8.53427 19.9856 9.14105 19.9856 9.51531 19.5951L16.0111 12.8169Z",
    fill: "#0177FD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight122X);
export default __webpack_public_path__ + "static/media/right-12@2x.4d3a6b58d41fc4e35d34124ed3d8300d.svg";
export { ForwardRef as ReactComponent };